import { ROTransaction, RWTransaction } from '../../../db'
import { Entity, Id, PaginatedResult, Context, Paging, Order } from '../../../common'
import { Code } from '../../kladr'

export interface MunicipalEntity extends Entity {
  name: string
  index: number
  kladrCode?: Code
}

export interface MunicipalEntityFilter {
  ids?: Id[]
  kladrCodes?: Code[]
  index?: number
  // Full text search by name
  search?: string
}

export enum MunicipalEntityOrderFields {
  NAME = 'name',
  INDEX = 'index',
  CREATED_AT = 'createdAt',
}

export interface MunicipalEntityFindOptions {
  filter?: MunicipalEntityFilter
  order?: Order<MunicipalEntityOrderFields> | undefined
  paging?: Paging
}

export interface MunicipalEntitiesRepository {
  findAll(tx: ROTransaction, opts?: MunicipalEntityFindOptions): Promise<PaginatedResult<MunicipalEntity>>
  findById(tx: ROTransaction, id: Id): Promise<MunicipalEntity | undefined>
  findByIndex(tx: ROTransaction, index: number): Promise<MunicipalEntity | undefined>
  findByIdNonDeleted(tx: ROTransaction, id: Id): Promise<MunicipalEntity | undefined>
  save(tx: RWTransaction, municipalEntity: MunicipalEntity): Promise<void>
  delete(tx: RWTransaction, id: Id, deletedAt: Date): Promise<void>
}

export type AddMunicipalEntityOpts = {
  id?: Id
  name: string
  index: number
  kladrCode?: Code
}

export type UpdateMunicipalEntityOpts = {
  name?: string
  index?: number
  kladrCode?: Code
}

export interface MunicipalEntitiesService {
  findAll(ctx: Context, opts?: MunicipalEntityFindOptions): Promise<PaginatedResult<MunicipalEntity>>
  findById(ctx: Context, id: Id): Promise<MunicipalEntity | undefined>
  findByIndex(ctx: Context, index: number): Promise<MunicipalEntity | undefined>
  findByIdNonDeleted(ctx: Context, id: Id): Promise<MunicipalEntity | undefined>
  add(ctx: Context, opts: AddMunicipalEntityOpts): Promise<Id>
  update(ctx: Context, id: Id, opts: UpdateMunicipalEntityOpts): Promise<void>
  delete(ctx: Context, id: Id): Promise<void>
}
